import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { LoadingScreen } from '../common/LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAdmin?: boolean
}

export function ProtectedRoute({ children, requireAdmin }: ProtectedRouteProps) {
  const { user, appUser, isLoading } = useAuthStore()
  const location = useLocation()

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!user || !appUser) {
    // Preserve where they were trying to go so /login can bounce them
    // back after sign-in. Used by deep links (punch.fyi/r/{code} → /messages/{id}).
    const next = `${location.pathname}${location.search}`
    const target = next && next !== '/'
      ? `/login?next=${encodeURIComponent(next)}`
      : '/login'
    return <Navigate to={target} replace />
  }

  if (appUser.status && appUser.status !== 'approved') {
    return <Navigate to="/login" replace />
  }

  if (requireAdmin && appUser.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
